import styled from "styled-components";
import { spacing, color } from "src/theme";
import { RefreshingAd } from "../RefreshingAd/RefreshingAd";

type MobileHeaderAdProps = {
  showAd: boolean;
};

export function MobileHeaderAd({ showAd }: MobileHeaderAdProps) {
  return (
    <Wrapper showAd={showAd} test-id="mobile-header-ad">
      <RefreshingAd
        slotConfigId="mobileHeader"
        variant="DisplayAd"
        adHeight={50}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div<{ showAd: boolean }>`
  display: ${(props) => (props.showAd ? "flex" : "none")};
  top: 0;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing.xl};
  background-color: ${color.n10};
`;
